module.exports = __webpack_public_path__ + "static/img/share.3ef9ffb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/ComicDetail/img/share/share.png
// module id = 495
// module chunks = 0